export default {
  category: 'Catégorie',
  categories: 'Catégories',
  verbose_category: 'une catégorie',
  related_categories: 'Catégories reliées',
  select_categories: 'Sélectionner une catégorie reliée'
};
